import fromNow from "../fromNow"

export const renderDatePostedForPost = (post) => {
    if (post?.dateApplied) {
        let result = fromNow(new Date(post?.dateApplied))
        return `Applied ${result}`
    }
    
    let result = fromNow(new Date(post?.datePosted))
    return `Posted ${result}`
}